<template>
  <div ref="layout" class="page-form page-base">
    <h3 class="title">销售计划变更单（公司/营销单元）</h3>

    <div class="form-container">
      <div class="tools">
        <form-button @click="$router.go(-1)">返回</form-button>
      </div>
      <el-form
        ref="form"
        :show-message="false"
        inline
        size="mini"
        label-width="120px"
        disabled
        :model="conditions"
      >
        <common-title title="基本信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item class="line-16" prop="plan_number">
              <template #label>
                销售计划编号
              </template>
              <el-input
                v-model="conditions.plan_number"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="line-16" prop="plan_number">
              <template #label>
                单据类型
              </template>
              <el-input value="销售计划变更单(公司/营销单元)" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="adj_reason" label="变更原因">
              <el-select
                v-model="conditions.adj_reason"
                placeholder=""
              >
                <el-option
                  v-for="item in selectDataOptions['A0003']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="备注">
              <el-input v-model="conditions.remark" type="textarea" rows="4" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="24">
            <common-title title="现有计划量" />
            <el-row>
              <el-col>
                <el-form-item label="总计划量(吨)">
                  <el-input v-model="conditions.total_qty" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :lg="8" :md="24">
            <common-title title="现有计划额（参考）" />
            <el-row>
              <el-col>
                <el-form-item class="line-16" label="">
                  <template #label>
                    总计划额(万元)
                  </template>
                  <el-input v-model="conditions.total_amt" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="24">
            <common-title title="本次调整计划量" />
            <el-row>
              <el-col>
                <el-form-item prop="curnt_adjqty" class="line-16" label="调整计划量(吨)">
                  <el-input v-model="conditions.curnt_adjqty" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :lg="8" :md="24">
            <common-title title="本次调整计划额（参考）" />
            <el-row>
              <el-col>
                <el-form-item class="line-16">
                  <template #label>
                    调整计划额(万元)
                  </template>
                  <el-input v-model="conditions.curnt_adjamt" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="状态变更记录" :custome-config="() => vxeShowCustom('xTable')">
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        />
      </TableCommon>
    </div>

  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { getSalePlanCompnayByNumber, getSalePlanCompnayChangeCreate } from '@/api/sap/sale-plan'
export default {
  data() {
    return {
      selectDataOptions: {},
      loading: false,
      conditions: {
        remark: '',
        adj_reason: '',
        total_amt: '',
        total_qty: '',
        curnt_adjamt: '',
        curnt_adjqty: '',
        plan_number: '',
        order_type: 'ZP04',
        porder_status: 'E001'
      },
      gridOptions: {
        data: [],
        columns: [
          { field: 'operationer', title: '操作员' },
          { field: 'oper_name', title: '操作员姓名' },
          { field: 'oper_status_text', title: '操作状态' },
          { field: 'changin_date', title: '变更日期' },
          { field: 'changin_time', title: '变更时间' }
        ]
      }
    }
  },
  created() {
    this.getSelectDictDataOrigin('A0003')
    this.getDetail()
  },
  methods: {
    async getDetail() {
      const { data } = await getSalePlanCompnayByNumber({ plan_order: this.$route.query.order })
      Object.assign(this.conditions, data.ls_head || {})
      this.gridOptions.data = data.lt_chg_history || []
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/components/salePlanChangeCompanyCheck.vue